import Flickity from 'flickity';

export default (el) => {
  return new Flickity(el, {
    initialIndex: 0,
    prevNextButtons: false,
    pageDots: false,
    wrapAround: true,
    adaptiveHeight: true,
    draggable: false,
  });
};
